import styled from '@emotion/styled'

const Container = styled.div`
  --size: ${({ theme }) => theme.size.height[400]};

  & {
    font-size: var(--fs-300);
    font-weight: 500;
    text-align: center;
    cursor: pointer;
    padding: 0;
    border: none;
    height: var(--size);
    min-width: 160px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: ${({ theme }) => theme.style.transitionTime[400]}
        background-color,
      ${({ theme }) => theme.style.transitionTime[400]} color;
    color: ${({ theme }) => theme.colors.gray[0]};
    background-color: transparent;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.primary[400]};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }

  &:active {
    background-color: ${({ theme }) => theme.colors.primary[600]};
  }
`

export default Container
